<div class="panel-heading">
	<span>SERVICE - {{node.service.name}}</span>
</div>
<div class="panel-body">
	<div class="form-group">
		<div class="row">
			<div class="col-sm-3"><label for=description>SERVICE</label></div>
			<div class="col-sm-5">
				<select class="form-control" [(ngModel)]="service" [ngModelOptions]="{standalone: true}" (change)="onSelectService()">
					<option [ngValue]="null" selected="selected">-- Choose -- </option>
					<option *ngFor="let service of services" [ngValue]="service">
						{{service.name}}
					</option>
				</select>
			</div>
		</div>
	</div>
</div>

<div class="panel-body">
	<div class="form-group">
		<div class="row">
			<div class="col-sm-3"><label for=description>FUNCTION</label></div>
			<div class="col-sm-5">
				<select class="form-control" [(ngModel)]="serviceFunction" [ngModelOptions]="{standalone: true}" (change)="onSelectServiceFunction()">
					<option [ngValue]="null" selected="selected">-- Choose -- </option>
					<option *ngFor="let function of serviceFunctions" [ngValue]="function">
						{{function.name}}
					</option>
				</select>
			</div>
		</div>
	</div>
</div>

<div class="panel-body" *ngIf="node.data != null">
	<ng-container *ngFor="let datum of node.data">
		<div class="form-group">
			<div class="row">
				<div class="col-sm-3"><label for=description>{{datum.property}}</label></div>
				<div class="col-sm-5">
					<input class="form-control" type="text" [(ngModel)]="datum.value" style="display: inline; width: 200px"
						[typeahead]="entities"
						(typeaheadLoading)="changeTypeaheadLoading($event)"
						(typeaheadOnSelect)="typeaheadOnSelect($event)"
						typeaheadOptionField="name" />
				</div>
			</div>
		</div>
	</ng-container>
</div>